import EvaluationNotesController from './evaluationNotesController';
import './evaluationNotes.scss';

const EvaluationNotes = {
    template: require('./evaluationNotesView.html'),
    controller: EvaluationNotesController
};

export default EvaluationNotes;




// WEBPACK FOOTER //
// ./src/app/pages/evaluation/components/notes/evaluationNotesComponent.js